import AppleWebPushConfig from './static/apple-pushpackage/website.json';
import {z} from 'zod';

import * as ContentItemLayouts from './blocks/ContentItem/index.js';


export default {

	// domain lang (html lang=) and other use
	lang: 'ro',

	// main domain name, used for redirects, content etc.
	domain: 'historia.ro',

	// alternate domain name , this is usually the cdn cname alias for cdn
	// used for loading videoplayer for use within amp (which requires a different domain than the main domain)
	alternateDomain: 'historia-ro.adh.reperio.news',

	// used as display in various places
	friendlyName: 'Historia',
	friendlyURL: 'https://historia.ro',
	logoURL: 'https://historia.ro/favicon-144-precomposed.png',

	paginationLimitPerPage: 50,

	// is this "ajax" site, svelte auto hydrate pages?
	hydrate: false,

	// xxx: is this still valid? type of articles to publish (grouping basically for custom logic), optional
	// content_type: ['article', 'blog_post'],

	// auto load data for this blocks and include in all pages (headers, footers, etc)
	// this is usefull if publishers wants to auto include via code specific blocks in the page.
	autoLoadGlobalBlocks: ['TopMenu_main_menu', 'Footer_footer', 'AdPosition_head', 'AdPosition_body_end'],

	// regex redirects on the front-end renderer
	redirects: {

		'\/\/www\.historia\.ro\/(.*)': {
			url: 'https://historia.ro/$1',
			status: 301
		},

		'.*/rss.xml': {
			url: 'https://historia.ro/rss/index',
			status: 301,
		},

		'.*\/a(\\d{1,})$': {
			url: 'https://historia.ro/article_old/$1',
			status: 301,
		},

		'.*\\/rd\-(\\d{1,})$': {
			url: 'https://historia.ro/article_old/$1',
			status: 301,
		},

		'/ads.txt': {
			url: 'https://adstxt.dev/648376083b/ads.txt',
			status: 302,
		}

	},

	appleWebPushConfig: AppleWebPushConfig,
	customContentFields: z.object({
		ads_disabled: z.boolean().optional(),
		edition_identifier: z.string().optional(),
		buy_url: z.string().optional(),
		authors_as_text: z.string().optional(),
	}),

	customCategoryFields: z.object({
		ads_disabled: z.boolean().optional(),
		content_item_layout: z.enum(Object.keys(ContentItemLayouts)).optional(),
		show_article_date: z.boolean().optional(),
	}),

}

export const MISC = {

	reviste_category_id: 9,

	logo: {
		width: 171,
		height: 40,
	},

	menuDefaultcolor: "#ffffff",
	menuBorderColor: "#dddddd",
	boxColor: "#7b8157",
	boxColorLight: "#fff",
	menuFontColor: "#111111",
	headingsColor: "#000000",
	headingsBorderColor: "#111",
	headingsBgColor: "none",
};

// Tags consumed by this theme's components as behavior flags or display
// badges rather than topics (ads/comments switches, title badges). The
// admin's tag assistant must neither suggest nor critique them.
export const SYSTEM_TAGS = [
	"noads",
	"sex",
	"advert",
	"advertorial",
];
